import { Input } from "@/components/ui/input";
import { Euro } from "lucide-react";
import { useCallback, useState } from "react";

interface PriceSectionProps {
  value?: number;
  onPriceChange: (price: number) => void;
}

export function PriceSection({ value = 0, onPriceChange }: PriceSectionProps) {
  const [displayValue, setDisplayValue] = useState<string>(value ? value.toString() : "");

  const handleChange = useCallback(
    (val: string) => {
      setDisplayValue(val);
      const clean = val.replace(",", ".");
      if (clean === "") {
        onPriceChange(0);
        return;
      }
      if (/^(\d+\.?\d*|\.\d+)$/.test(clean) && !clean.endsWith(".")) {
        const num = parseFloat(clean);
        if (!isNaN(num) && num >= 0) {
          onPriceChange(num);
        }
      }
    },
    [onPriceChange]
  );

  return (
    <div className="mb-4">
      <div className="text-lg font-semibold">Prix de l'inscription</div>
      <div className="mb-2 text-sm text-gray-700">
        Indiquez le montant total de l’inscription (vous pourrez créer vos forfaits ultérieurement dans les paramètres de l’outil)
      </div>
      <div className="w-28">
        <div className="flex items-center">
          <Input type="text" value={displayValue} onChange={(e) => handleChange(e.target.value)} placeholder="0.00" className="text-center bg-white" />
          <Euro className="ml-2 h-6 w-6" />
        </div>
      </div>
    </div>
  );
}
